import React from "react";

const SocialButton = ({ icon, url }) => (
  <a href={url} className='footer__social-button' target='_blank'>{ icon }</a>
);

export default SocialButton;